import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import NavBar from '../components/NavBar'
import { logoutUser } from '../../user/UserActions'

const mapStateToProps = (state) => {
    return {
        user : state.user
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        logoutUser: () => {
        	return dispatch(logoutUser())
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavBar)



// WEBPACK FOOTER //
// ./src/core/containers/NavBarContainer.js